module.exports = __webpack_public_path__ + "images/emoji/u5408.f095923db87c3cf8b23b.png";